const isNonAsciiString = (text) => {
	if (typeof text !== 'string') return false;
	
	const isNonAsciiRegex = new RegExp(/[^\x\00-\x7F]+/g);
	return isNonAsciiRegex.test(text);
};

export {
	isNonAsciiString,
};